// Matching rerelease/game.h:1584-1593
export enum LayoutFlags {
    LAYOUTS_LAYOUT = 1,
    LAYOUTS_INVENTORY = 2,
    LAYOUTS_HIDE_HUD = 4,
    LAYOUTS_INTERMISSION = 8,
    LAYOUTS_HELP = 16,
    LAYOUTS_HIDE_CROSSHAIR = 32
}
